import { render, staticRenderFns } from "./SupplierDetailsDialog.vue?vue&type=template&id=3d5b4782&scoped=true"
import script from "./SupplierDetailsDialog.vue?vue&type=script&lang=js"
export * from "./SupplierDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5b4782",
  null
  
)

export default component.exports